import React from 'react'
import { useTranslation } from 'react-i18next'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { LanguageSelectorProvider } from '@vallourec-ui/vallourec-ui'

import PrivateRoute from './containers/router/PrivateRoutes'

import Flow from './pages/Flow'
import Footer from './pages/Footer'
import GenerateReport from './pages/GenerateReport'
import Home from './pages/Home'
import Login from './pages/Login'
import Permissions from './pages/Permissions'
import SearchReport from './pages/SearchReport'

import RemarkDefinition from './pages/Remark'
import SearchReportOrders from './pages/SearchReportOrders'
import { DocumentApprovalProvider } from './stores/DocumentApprovalStore'
import { GenerateReportProvider } from './stores/GenerateReportStore'
import { HomeProvider } from './stores/HomeStore'
import { SearchReportOrdersProvider } from './stores/SearchReportOrdersStore'
import { SearchReportProvider } from './stores/SearchReportStore'

const Routers = () => {
  const { t } = useTranslation()

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          key="login"
          element={
            <LanguageSelectorProvider>
              <Login
                systemName={t('login.title')}
                appName={t('login.acronym')}
              />
            </LanguageSelectorProvider>
          }
        />
        {['/home', '/'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-1`}
              path={path}
              element={
                <HomeProvider>
                  <Home title={t('home.title')} subtitle={t('home.welcome')} />
                </HomeProvider>
              }
            />
          </Route>
        ))}
        {['/generate-report'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-2`}
              path={path}
              element={
                <GenerateReportProvider>
                  <GenerateReport
                    title={t('home.generateReport.title', "Gerar Relatório")}
                    subtitle={t('home.generateReport.subtitle', "Gere relatórios a partir dos dados do sistema")}
                  />
                </GenerateReportProvider>
              }
            />
          </Route>
        ))}
        {['/search-report'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-3`}
              path={path}
              element={
                <SearchReportProvider>
                  <SearchReport
                    title={t('home.searchReport.title', "Pesquisar Relatório")}
                    subtitle={t('home.searchReport.subtitle', "Encontre relatórios existentes")}
                  />
                </SearchReportProvider>
              }
            />
          </Route>
        ))}
        {['/permissions-management'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-4`}
              path={path}
              element={
                <Permissions
                  title={t('home.permissionsManagement.title', "Gestão de Permissão de Usuários")}
                  subtitle={t('home.permissionsManagement.subtitle', "Gerencie dados e permissões dos usuários")}
                />
              }
            />
          </Route>
        ))}
        {['/footer-settings'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-5`}
              path={path}
              element={
                <Footer
                  title={t('home.footerSettings.title', "Config Footer Settings")}
                  subtitle={t('home.footerSettings.subtitle', "Gerencie as informações exibidas nos rodapés")}
                />
              }
            />
          </Route>
        ))}
        {['/search-report-orders'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-6`}
              path={path}
              element={
                <SearchReportOrdersProvider>
                  <SearchReportOrders
                    title={t('home.searchReportOrders.title', "Procurar por Ordem")}
                    subtitle={t('home.searchReportOrders.subtitle', "Procurar relatório pela Ordem")}
                  />
                </SearchReportOrdersProvider>
              }
            />
          </Route>
        ))}
        {['/remark-definition'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-7`}
              path={path}
              element={
                <RemarkDefinition
                  title={t('home.remarkDefinition.title', "Remark Definition")}
                  subtitle={t('home.remarkDefinition.subtitle', "Defina e gerencie observações")}
                />
              }
            />
          </Route>
        ))}
        {['/approval-flow'].map((path) => (
          <Route element={<PrivateRoute />} key={`${path}-1`}>
            <Route
              key={`${path}-8`}
              path={path}
              element={
                <DocumentApprovalProvider>
                  <Flow
                    title={t('home.approvalFlow.title', "Fluxo de Aprovação")}
                    
                  />
                </DocumentApprovalProvider>
              }
            />
          </Route>
        ))}
      </Routes>
    </BrowserRouter>
  )
}

export default Routers
